import React from 'react';
import {
    Button,
    Space,
    Typography,
    List,
    Card,
    Tooltip, Input, Modal, notification
} from "antd";
import {getFeConfig, updateEASInfo, visualize} from "../api/api";
import {CloseOutlined, EditOutlined, SaveOutlined} from "@ant-design/icons";
import {unstable_batchedUpdates} from "react-dom";
import {Q4USUtil} from "@q4us-sw/q4us-util";
import {resolve} from "@q4us-sw/q4us-ui/lib/Cell";
import {EditCellView, RowContext} from "@q4us-sw/q4us-ui/lib/TableV2";

const {TextArea} = Input;

export const Item = ({column, value: v, submit}) => {

    const [edit, setEdit] = React.useState(false)
    const [display, setDisplay] = React.useState(v)
    const [value, setValue] = React.useState({data: {[column.name]: v}})
    const [open,setOpen] = React.useState(false)
    const [ellipsis, setEllipsis] = React.useState(true);

    return <React.Fragment>
    <Card
        className={`eas-info-item`}
        title={<Tooltip title={column.title}>{column.title}</Tooltip>}
        extra={<Space>
            {(!edit) && <Button icon={<EditOutlined/>} key={"edit"} onClick={async () => {
                if (column.name === 'invoice_notes') {
                    setOpen(true)
                }
                else {
                    setEdit(true)
                }

            }}/>}
            {edit && <Button icon={<SaveOutlined/>} key={"save"} onClick={async () => {
                const [[p, q]] = Object.entries(value.data);
                let res = {status: 200};
                if (submit) {
                    await submit({key: p, value: q}).catch(e => {
                        res = {status: 401}
                    })
                } else {
                    if(p==='new_invoice_delay' && (q < 0)){
                        notification.error({message: "Invalid Delay for new invoice notifications"});
                        res = {status : 406}
                    } else {
                        res = await updateEASInfo({key: p, value: q})
                    }
                }

                if (res.status === 200) {
                    unstable_batchedUpdates(() => {
                        setEdit(false)
                        setDisplay(q)
                    })
                } else {
                    unstable_batchedUpdates(() => {
                        setEdit(false)
                        setValue({data: {[column.name]: v}})
                    })
                }

            }}/>}
            {edit && <Button icon={<CloseOutlined/>} key={"close"} onClick={async () => {
                unstable_batchedUpdates(() => {
                    setEdit(false)
                    setValue({data: {[column.name]: v}})
                })
            }}/>}
        </Space>}
    >
        {(!edit) && <Typography.Text className={`eas-info-value`} style={
                ellipsis
                    ? {
                        width: 200
                    }
                    : undefined
                }
                     ellipsis={
                         ellipsis
                             ? {
                                 rows: 2,
                                 expandable: true,
                             }
                             : false
                     }>
            {column.type === 'NUMBER' && column.enums == null ? Q4USUtil.roundToDecimal((display || 0), column.precision).toFixed(column.precision) : resolve({
                ...column,
                value: display,
                precision: 2
            })}
        </Typography.Text>}
        {edit && <RowContext.Provider value={{edit: value, setEdit: setValue, row: value.data, index: 0}}>
            <EditCellView required={true} name={column.name} type={column.type} title={column.title} enums={column.enums}/>
        </RowContext.Provider>}
    </Card>

        <Modal
            onCancel={() => setOpen(false)}
            onOk={async () => {
               const response = await updateEASInfo({key: 'invoice_notes', value: value.data.invoice_notes})
               if (response.status === 200) {
                   setOpen(false)
                   setDisplay(value.data.invoice_notes)
               }
               else {
                   notification.error({message: `Request failed with ${response.status} error`});
               }
            }
            }
            closable={true}
            title={'Enter invoice notes'}
            visible={open}
        >
            <TextArea rows={8} onChange={(e) => {setValue({data: {invoice_notes: e.target.value}})}} defaultValue={display}/>
        </Modal>

    </React.Fragment>
}

export const InvoiceSettings = () => {
    const [opt, setOpt] = React.useState({config: [], data: {}})

    const load = async () => {
        const {data: {rows: config} = {}} = await getFeConfig('invoice_settings') || {};
        const {data: {rows = []} = {}} = await visualize('eas_info') || {};

        const data = rows.reduce((acc, {name, value, type}) => {
            acc[name] = type === 'NUMBER' ? Number(value) : type === 'BOOLEAN' ? value === 'true' : value;
            return acc;
        }, {})
        setOpt({config, data})

    }

    React.useEffect(() => {
        load();
    }, [])

    return <React.Fragment>
        <div className={`eas-info-wrap`}>
            <List
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 2,
                    xl: 4,
                    xxl: 4
                }}
                dataSource={opt.config}
                renderItem={item => <List.Item>
                    <Item column={item} value={opt.data[item.name]}
                          submit={undefined}/>
                </List.Item>}
            />
        </div>
    </React.Fragment>
};
